/**
 * Vertical Image Links — stub custom element.
 * Layout is handled entirely by CSS: left content column is position:sticky,
 * right card column scrolls normally showing all cards.
 */

class VerticalImageLinks extends HTMLElement {}

customElements.define('vertical-image-links-component', VerticalImageLinks);
